import { useState } from 'react';
import useFetch from '../hooks/useFetch'
import { objectToQueryString } from '../utils';
import { apiWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  const [trainers, setTrainers] = useState([])
  const [trainerEventCompensation, setTrainerEventCompensation] = useState()

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchTrainers = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/trainers?${objectToQueryString(filters)}`, { method: 'GET' })
      const jsonData = await response.json()
      if (jsonData.error) {
        setTrainers([])
      } else {
        setTrainers(jsonData)
      }
     setIsLoading(false)
    } catch (e) {
      console.log(e)
      setTrainers([])
      setIsLoading(false)
    }
  }

  const fetchAllTrainers = async (flightData) => {
    return apiWrapper({
      fetch,
      url: `events/event/trainers/all`,
      options: { method: 'GET' }
    });
  }

  const addNewTrainer = async (trainerData) => {
    return apiWrapper({
      fetch,
      url: `events/event/trainers/new`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: trainerData })
      }
    });
  }

  const updateTrainer = async (trainerData) => {
    return apiWrapper({
      fetch,
      url: `events/event/trainers/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: trainerData })
      }
    });
  }

  const deleteTrainer = async (trainerData) => {
    return apiWrapper({
      fetch,
      url: `events/event/trainers/delete`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: trainerData })
      }
    });
  }

  const calculateNames = async (trainerData) => {
    return apiWrapper({
      fetch,
      url: `events/event/trainers/calculateNames`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: trainerData })
      }
    });
  }

  const fetchTrainerEventCompensation = async (trainerId, eventId) => {
    setIsLoading(true)
    try {
      const response = await fetch(`trainer/eventCompensation?userId=${trainerId}&eventId=${eventId}`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setTrainerEventCompensation()
      } else {
        setTrainerEventCompensation(jsonData)
      }
    } catch (e) {
      setTrainerEventCompensation({})
    }
    setIsLoading(false)
  }

  return {
    isLoading,
    trainers,
    fetchTrainers,
    fetchAllTrainers,
    addNewTrainer,
    deleteTrainer,
    updateTrainer,
    calculateNames,
    trainerEventCompensation,
    fetchTrainerEventCompensation
  }
}